import React from "react";

export default function ModalContainer({ children }) {
  return <div style={{ padding: "1rem 2rem" }}>{children}</div>;
}
